import { render, staticRenderFns } from "./Guardias.vue?vue&type=template&id=46066eb8&"
import script from "./Guardias.vue?vue&type=script&lang=js&"
export * from "./Guardias.vue?vue&type=script&lang=js&"
import style0 from "./Guardias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports